import { Box, Typography, Grid, Stack, Alert } from '@mui/material';
import dayjs from 'dayjs';
import { TimeSlot } from './time-slot';
import { useIntlTranslations } from '@libs/intl/intl.hooks';

type AvailableSlotsGridProps = {
  availableSlots: { start: string; end: string }[];
  selectedDate: Date;
  previewStartTime?: string;
  onSlotClick: (slot: { start: string; end: string }) => void;
  hasServiceSelected: boolean;
  noSlotsReason?: 'NOT_WORKING' | 'FULLY_BOOKED';
};

export const AvailableSlotsGrid = ({
  availableSlots,
  selectedDate,
  previewStartTime,
  onSlotClick,
  hasServiceSelected,
  noSlotsReason,
}: AvailableSlotsGridProps) => {
  const { t } = useIntlTranslations('addVisitForm');

  if (availableSlots.length === 0 && hasServiceSelected) {
    const messageKey =
      noSlotsReason === 'FULLY_BOOKED'
        ? 'noAvailableSlotsFullyBooked'
        : noSlotsReason === 'NOT_WORKING'
          ? 'noAvailableSlotsNotWorking'
          : 'noAvailableSlots';

    return (
      <Alert
        severity={noSlotsReason === 'NOT_WORKING' ? 'warning' : 'error'}
        sx={{ fontSize: '0.875rem' }}
      >
        {t(messageKey)}
      </Alert>
    );
  }

  return (
    <Box sx={{ mt: 1 }}>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h6" sx={{ mb: 1 }}>
          {t('availableSlotsTitle')}
        </Typography>
        <Typography variant="h6" color="primary.main" sx={{ mb: 1 }}>
          {dayjs(selectedDate).format('dddd, D. MMMM')}
        </Typography>
      </Stack>
      <Grid container spacing={2}>
        {availableSlots.map((slot, index) => (
          <TimeSlot
            key={`${slot.start}-${index}`}
            slot={slot}
            isSelected={previewStartTime === slot.start}
            onSlotClick={onSlotClick}
          />
        ))}
      </Grid>
    </Box>
  );
};
